module.exports = __webpack_public_path__ + "img/potentialcustomer_icon.a5b27ab6.svg";